import cloneDeep from "lodash/cloneDeep";

export const clanNameTag = (actionTypes, initialState) => {
  return (state = initialState, action) => {
    let fieldData = null,
        errorData = null;
    switch (action.type) {
      case actionTypes.startOperation:
        return Object.assign({}, state, {
          isProcessing: true,
          error: null
        });
      case actionTypes.stopOperation:
        return Object.assign({}, state, {
          isProcessing: false
        });
      case actionTypes.updateFieldValue:
        fieldData = Object.assign({}, initialState[action.field], {
          value: action.value,
          error: action.error
        });

        if (state.error && state.error.errors) {
          errorData = cloneDeep(state.error);
          errorData.errors[action.field] = void 0;
        }

        return Object.assign({}, state, {
          [action.field]: fieldData,
          error: errorData || state.error
        });
      case actionTypes.startCheckAvailability:
        return Object.assign({}, state, {
          [action.field]: Object.assign({}, state[action.field], { isValidating: true })
        });
      case actionTypes.finishCheckAvailability:
        fieldData = Object.assign({}, initialState[action.data.field], {
          value: action.data.value,
          available: action.data.available,
          error: action.data.error
        });
        return Object.assign({}, state, {
          [action.data.field]: fieldData
        });
      case actionTypes.updateError:
        return Object.assign({}, state, {
          isProcessing: false,
          isCheckingStatus: false,
          error: action.error
        });
      case actionTypes.setInitialState:
        return Object.assign({}, initialState);
      case actionTypes.setStatusUrl:
        return Object.assign({}, state, {
          statusUrl: action.url
        });
      case actionTypes.startCheckingStatus:
        return Object.assign({}, state, {
          isCheckingStatus: true
        });
      case actionTypes.finishCheckingStatus:
        return Object.assign({}, state, {
          isCheckingStatus: false
        });
      default:
        return state;

    }
  };
};